import { inject, injectable } from "tsyringe";
import { TOKEN_IWrapNavigation } from "./WrapNavigation";
import type { IWrapNavigation } from "./WrapNavigation";
import log from "loglevel";

export const TOKEN_INavigateTo = Symbol("INavigateTo");

export interface INavigateTo {
    /**
     * Navigates to a project by its ID
     * @param id The project ID to navigate to
     */
    NavigateToProjectId(id: string): void;

    /**
     * Silently navigates to a project by its ID
     * @param id The project ID to navigate to
     */
    SilentNavigateToProjectId(id: string): void;

    /**
     * Swaps to the project selection view
     */
    SwapProject(): void;

}

@injectable()
export class NavigateTo implements INavigateTo {

    constructor(
        @inject(TOKEN_IWrapNavigation) private navigation: IWrapNavigation
    ) {
    }

    public NavigateToProjectId = (id: string) => {
        const url = `/project/${id}`;
        log.info(`Navigating to project: ${id}`, { url });
        this.navigation.navigateTo(url);
    }

    public SilentNavigateToProjectId = (id: string) => {
        const url = `/project/${id}`;
        log.info(`Silently navigating to project: ${id}`, { url });
        this.navigation.navigateTo(url, true);
    }

    public SwapProject = () => {
        log.info("Swapping to project selection view");
        this.navigation.navigateTo("/projects");
    }
}